module.exports = __webpack_public_path__ + "static/index/img/baikal-403.f0807c0a.jpg";